import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import pick from 'lodash/pick';
import dynamic from 'next/dynamic';
import { BASE_FILE_URL, BASE_URL, BASE_URL_CT, BASE_URL_DT } from './constants';
import { stringifyQuery } from './ultils';

export const getWebsiteCodeHeader = (websiteCode) => {
  return !isEmpty(websiteCode) && websiteCode !== 'undefined' ? websiteCode : null;
};

export const fetchMenuTree = async (websiteCode, query) => {
  try {
    const res = await fetch(`${BASE_URL}/menus/getMenuTree?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return [];
  } catch {
    return [];
  }
};

// const fetchHeaderBanners = async (websiteCode, query) => {
//   try {
//     if (locale) {
//       const res = await fetch(`${BASE_URL}/bannerSystems?${stringifyQuery(query)}`, {
//         headers: {
//           websiteCode: getWebsiteCodeHeader(websiteCode),
//           'Content-Type': 'application/json',
//         },
//       });
//       const resJson = await res.json();
//       if (!resJson?.code) {
//         return resJson;
//       }
//       return {};
//     }
//   } catch {
//     return {};
//   }
// };

export async function fetchRunnerTexts(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/textRunners/getTextRunnersPublic?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return [];
  } catch {
    return [];
  }
}

export async function fetchFeaturedEvents(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/postss?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchNewTexts(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/postss?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });

    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchPostsByShowcaseWalls(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/showcaseWalls?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchTypeBanners(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/bannerSystems?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });

    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchDraftDocuments(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/draftProposals/publising?${stringifyQuery(query)}`, {
      method: 'GET',
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchMedias(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/mediaContents/publising?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchLinkPages(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/linkSystems?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode, query),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    } else {
      return {};
    }
  } catch {
    return {};
  }
}

export async function fetchFooterSystems(websiteCode) {
  try {
    const res = await fetch(`${BASE_URL}/footerSystems`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });

    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchQuestions(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/questions/publishing?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchContacts(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/contacts?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchTags(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/tags?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });

    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchMenus(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/menus?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchOnePostsBySlug(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/postss/getOneSlug?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return null;
  } catch {
    return null;
  }
}
export async function fetchPostsByMenuSlug(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/postss?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchPostss(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/postss?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchCrawlPostss(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/crawlPostss/publising?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode), // Sử dụng websiteCode từ props hoặc mặc định
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchCategorys(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/categorys?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchYKienCuTris(query) {
  try {
    const res = await fetch(`${BASE_URL_CT}/yKienCuTris/getPublicYKien?${stringifyQuery(query)}`);
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchDonThus(query) {
  try {
    const res = await fetch(`${BASE_URL_DT}/letters/getLetterPublic?${stringifyQuery(query)}`, {});
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function fetchDraftProposalBySlug(websiteCode, slug, query) {
  try {
    const res = await fetch(`${BASE_URL}/draftProposals/publisingBySlug/${slug}?${stringifyQuery(query)}`, {
      method: 'GET',
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return null;
  } catch {
    return null;
  }
}

export async function fetchDraftProposalFeedbacks(websiteCode, slug, query) {
  try {
    const res = await fetch(`${BASE_URL}/draftProposals/publisingBySlug/feedbacks/${slug}?${stringifyQuery(query)}`, {
      method: 'GET',
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export async function getMediaContentSlug(websiteCode, slug) {
  try {
    const res = await fetch(`${BASE_URL}/mediaContents/publising/slugs/${slug}`, {
      headers: {
        websiteCode: !isEmpty(websiteCode) && websiteCode !== 'undefined' ? websiteCode : null, // Sử dụng websiteCode từ props hoặc mặc định
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return null;
  } catch {
    // setArticles([]);
    return null;
  }
}

export async function fetchLocaleMessages(websiteCode, locale) {
  try {
    const res = await fetch(`${BASE_URL}/languages/publishing?status=active&code=${locale}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    const matched = get(resJson, 'results', [])?.find((lang) => lang.code === locale);

    if (matched?.fileUrl) {
      const messagesRes = await fetch(`${BASE_FILE_URL}/${matched.fileUrl}`, {});
      if (messagesRes.ok) {
        return await messagesRes.json();
      }
      return null;
    }
    return null;
  } catch {
    return null;
  }
}

export async function getPublicPostsByShowcaseWalls(websiteCode, query) {
  try {
    const res = await fetch(`${BASE_URL}/postss/getPublicPostsByShowcaseWalls?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();

    if (!resJson?.code) {
      return resJson;
    }
    return {};
  } catch {
    return {};
  }
}

export const fetchPageConfig = async (websiteCode, query) => {
  try {
    const res = await fetch(`${BASE_URL}/pageConfigs/getPageConfigByPath?${stringifyQuery(query)}`, {
      headers: {
        websiteCode: !isEmpty(websiteCode) && websiteCode !== 'undefined' ? websiteCode : null, // Sử dụng websiteCode từ props hoặc mặc định
        'Content-Type': 'application/json',
      },
    });
    const resJson = await res.json();
    if (!resJson?.code) {
      return resJson;
    }
    return null;
  } catch {
    return null;
  }
};

export const pageConfig = {
  AccessInformation: {
    component: dynamic(() => import('@/components/AccessInformation')),
    fetchData: async () => {},
  },
  Activity2Columns: {
    component: dynamic(() => import('@/components/Activity2Columns')),
    fetchData: {
      postsByShowcaseWalls: async (locale, websiteCode, query) => {
        const res = await fetchPostsByShowcaseWalls(websiteCode, {
          ...pick(query ?? {}, []),
          status: 'active',
          limit: 999,
          languageCode: locale,
          onlyGet: false,
          sortBy: 'numberIndex:asc',
        });
        const showcaseWalls = get(res, 'results', []);
        const showcaseWallResults = await getPublicPostsByShowcaseWalls(websiteCode, {
          showcaseWalls: showcaseWalls.map((wall) => wall.id),
          limit: 5,
          languageCode: locale,
        });

        showcaseWalls.forEach((wall) => {
          wall.postss = get(showcaseWallResults, 'results', []).filter((post) => post.showcaseWallId === wall.id);
        });
        return {
          ...res,
          results: showcaseWalls,
        };
      },
    },
  },
  ActivityBanner: {
    component: dynamic(() => import('@/components/ActivityBanner')),
    fetchData: {
      bannerMiddles: async (locale, websiteCode, query) => {
        const res = await fetchTypeBanners(websiteCode, {
          limit: 9999,
          ...pick(query ?? {}, []),
          type: 'middle',
          languageCode: locale,
          limit: 9999,
        });
        return res;
      },
    },
  },
  ActivityOther: {
    component: dynamic(() => import('@/components/ActivityOther')),
    fetchData: {
      postsByShowcaseWalls: async (locale, websiteCode, query) => {
        const res = await fetchPostsByShowcaseWalls(websiteCode, {
          ...pick(query ?? {}, []),
          status: 'active',
          limit: 999,
          languageCode: locale,
          onlyGet: false,
          sortBy: 'numberIndex:asc',
        });
        const showcaseWalls = get(res, 'results', []);
        const showcaseWallResults = await getPublicPostsByShowcaseWalls(websiteCode, {
          showcaseWalls: showcaseWalls.map((wall) => wall.id),
          limit: 5,
          languageCode: locale,
        });

        showcaseWalls.forEach((wall) => {
          wall.postss = get(showcaseWallResults, 'results', []).filter((post) => post.showcaseWallId === wall.id);
        });
        return {
          ...res,
          results: showcaseWalls,
        };
      },
    },
  },
  Contact: {
    component: dynamic(() => import('@/page/LienHePage/components/Contact')),
    fetchData: {
      contacts: async (locale, websiteCode, query) => {
        const res = await fetchContacts(websiteCode, {
          ...pick(query ?? {}, []),
          status: 'active',
          languageCode: locale,
        });
        return res;
      },
    },
  },
  HoiDap: {
    component: dynamic(() => import('@/page/HoiDapPage/components/HoiDap')),
    fetchData: {
      questions: async (locale, websiteCode, query) => {
        const res = await fetchQuestions(websiteCode, {
          ...pick(query ?? {}, []),
          page: 1,
          limit: 9999,
        });
        return res;
      },
    },
  },
  SoDoTrang: {
    component: dynamic(() => import('@/page/SoDoCongPage/components/SoDo')),
    fetchData: {
      menuTree: async (locale, websiteCode, query) => {
        const res = await fetchMenuTree(websiteCode, {
          ...pick(query ?? {}, []),
          languageCode: locale ?? 'vi',
          status: 'active',
        });

        return res;
      },
    },
  },
  DraftDocument: {
    component: dynamic(() => import('@/components/DraftDocument')),
    fetchData: {
      draftDocuments: async (locale, websiteCode, query) => {
        const res = await fetchDraftDocuments(websiteCode, {
          limit: 2,
          page: 1,
          ...pick(query ?? {}, []),
          sortBy: 'createdAt:desc',
        });
        return res;
      },
    },
  },
  Event: {
    component: dynamic(() => import('@/components/Event')),
    fetchData: {
      draftDocuments: async (locale, websiteCode, query) => {
        const res = await fetchDraftDocuments(websiteCode, {
          limit: 2,
          page: 1,
          ...pick(query ?? {}, []),
          sortBy: 'createdAt:desc',
        });
        return res;
      },
      homeMedias: async (locale, websiteCode, query) => {
        const res = await fetchMedias(websiteCode, {
          page: 1,
          limit: 3,
          ...pick(query ?? {}, []),
          statusDraft: 'processing',
          sortBy: 'createdAt:desc',
          types: ['video', 'image'],
        });
        return res;
      },
    },
  },
  EventBanner: {
    component: dynamic(() => import('@/components/EventBanner')),
    fetchData: {
      bannerMiddles: async (locale, websiteCode, query) => {
        const res = await fetchTypeBanners(websiteCode, {
          limit: 9999,
          ...pick(query ?? {}, []),
          type: 'middle',
          languageCode: locale,
          limit: 9999,
        });
        return res;
      },
    },
  },
  FeaturedEvent: {
    component: dynamic(() => import('@/components/FeaturedEvent')),
    fetchData: {
      featuredEvents: async (locale, websiteCode, query) => {
        const res = await fetchFeaturedEvents(websiteCode, {
          ...pick(query ?? {}, []),
          isPublic: true,
          isPopular: true,
          populate: 'menuId',
          limit: 5,
          sortBy: 'createdAt:desc',
          select: 'imgaeUrls menuId title summary slug imgaeUrlSharps',
          languageCode: locale,
        });
        return res;
      },
    },
  },
  Footer: {
    component: dynamic(() => import('@/components/Footer')),
    fetchData: {
      footerSystems: async (locale, websiteCode, query) => {
        const res = await fetchFooterSystems(websiteCode, {
          ...pick(query ?? {}, []),
        });
        return res;
      },
    },
  },
  Header: {
    component: dynamic(() => import('@/components/Header')),
    fetchData: {
      menuTree: async (locale, websiteCode, query) => {
        const res = await fetchMenuTree(websiteCode, {
          ...pick(query ?? {}, []),
          languageCode: locale ?? 'vi',
          status: 'active',
        });

        return res;
      },
    },
  },
  HeaderBanner: {
    component: dynamic(() => import('@/components/HeaderBanner')),
    fetchData: {
      headerBanners: async (locale, websiteCode, query) => {
        const res = await fetchTypeBanners(websiteCode, {
          limit: 9999,
          ...pick(query ?? {}, []),
          type: 'header',
          languageCode: locale || undefined,
        });
        return res;
      },
    },
  },
  HomeMedia: {
    component: dynamic(() => import('@/components/HomeMedia')),
    fetchData: {
      homeMedias: async (locale, websiteCode, query) => {
        const res = await fetchMedias(websiteCode, {
          page: 1,
          limit: 3,
          ...pick(query ?? {}, []),
          statusDraft: 'processing',
          sortBy: 'createdAt:desc',
        });
        return res;
      },
    },
  },
  LinkPage: {
    component: dynamic(() => import('@/components/LinkPage')),
    fetchData: {
      linkPages: async (locale, websiteCode, query) => {
        const res = await fetchLinkPages(websiteCode, {
          ...pick(query ?? {}, []),
        });
        return res;
      },
    },
  },
  Menu: {
    component: dynamic(() => import('@/components/Menu')),
    fetchData: {
      menuTree: async (locale, websiteCode, query) => {
        const res = await fetchMenuTree(websiteCode, {
          ...pick(query ?? {}, []),
          languageCode: locale ?? 'vi',
          status: 'active',
        });

        return res;
      },
    },
  },
  NewText: {
    component: dynamic(() => import('@/components/NewText')),
    fetchData: {
      newTexts: async (locale, websiteCode, query) => {
        const res = await fetchNewTexts(websiteCode, {
          ...pick(query ?? {}, []),
          isPublic: true,
          populate: 'menuId,sourceId',
          sortBy: 'issuanceDate:desc',
          postType: 'document',
          languageCode: locale,
          limit: 6,
          select: 'imgaeUrls menuId title summary slug endExpirationDate expirationDate issuanceDate content',
        });
        return res;
      },
    },
  },
  OtherBanner: {
    component: dynamic(() => import('@/components/OtherBanner')),
    fetchData: {
      footerBanners: async (locale, websiteCode, query) => {
        const res = await fetchTypeBanners(websiteCode, {
          limit: 9999,
          ...pick(query ?? {}, []),
          type: 'footer',
          languageCode: locale || undefined,
        });
        return res;
      },
    },
  },
  PostsByActivity: {
    component: dynamic(() => import('@/components/PostsByActivity')),
    fetchData: async () => {},
  },
  PostsDetail: {
    component: dynamic(() => import('@/components/PostsDetail')),
    fetchData: async () => {},
  },
  PostsGeneral: {
    component: dynamic(() => import('@/components/PostsGeneral')),
    fetchData: async () => {},
  },
  PostsMain: {
    component: dynamic(() => import('@/components/PostsMain')),
    fetchData: {
      featuredEvents: async (locale, websiteCode, query) => {
        const res = await fetchFeaturedEvents(websiteCode, {
          ...pick(query ?? {}, []),
          isPublic: true,
          isPopular: true,
          populate: 'menuId',
          limit: 1,
          sortBy: 'createdAt:desc',
          select: 'imgaeUrls menuId title summary slug imgaeUrlSharps',
          languageCode: locale,
        });
        return res;
      },
    },
  },
  PostsRelated: {
    component: dynamic(() => import('@/components/PostsRelated')),
    fetchData: {
      featuredEvents: async (locale, websiteCode, query) => {
        const res = await fetchFeaturedEvents(websiteCode, {
          ...pick(query ?? {}, []),
          isPublic: true,
          isPopular: true,
          populate: 'menuId',
          limit: 5,
          sortBy: 'createdAt:desc',
          select: 'imgaeUrls menuId title summary slug imgaeUrlSharps',
          languageCode: locale,
        });
        return res;
      },
    },
  },
  RightBanner: {
    component: dynamic(() => import('@/components/RightBanner')),
    fetchData: {
      rightBanners: async (locale, websiteCode, query) => {
        const res = await fetchTypeBanners(websiteCode, {
          limit: 9999,
          ...pick(query ?? {}, []),
          type: 'side_bar',
          languageCode: locale || undefined,
          sortBy: 'numberIndex:asc',
        });
        return res;
      },
    },
  },
  RunnerText: {
    component: dynamic(() => import('@/components/RunnerText')),
    fetchData: {
      runnerTexts: async (locale, websiteCode, query) => {
        const res = await fetchRunnerTexts(websiteCode, {
          ...pick(query ?? {}, []),
          languageCode: locale,
        });
        return res;
      },
    },
  },
  ChiTietBaiViet: {
    component: dynamic(() => import('@/page/ChiTietBaiVietPage/components/ChiTietBaiViet')),
    fetchData: {
      chiTietBaiViet: async (locale, websiteCode, query, propsData) => {
        let isPostMenu = false;
        let posts = await fetchOnePostsBySlug(websiteCode, {
          slug: propsData.slugDetail,
        });
        if (!posts) {
          posts = await fetchPostsByMenuSlug(websiteCode, {
            menuSlug: propsData.slugDetail,
            limit: 1,
          });
          posts = get(posts, 'results[0]');
          isPostMenu = true;
        }
        let relatedPosts = [];
        if (!get(posts, 'postsRelated', []).length) {
          relatedPosts = await fetchPostss(websiteCode, {
            isPublic: true,
            sortBy: 'createdAt:desc',
            populate: 'menuId,sourceId',
            menuSlug: posts?.menu?.slug,
            limit: 4,
            showcaseWalls: (posts, 'showcaseWalls', []).map((item) => item.id),
          });

          relatedPosts = get(relatedPosts, 'results', []).filter((item) => item?.id !== posts?.id);
        } else {
          relatedPosts = posts.postsRelated;
        }
        return {
          _data: {
            isPostMenu,
            posts,
            relatedPosts,
          },
        };
      },
      tags: async (locale, websiteCode, query) => {
        const res = await fetchTags(websiteCode, {
          ...pick(query ?? {}, []),
          limit: 9999,
        });
        return get(res, 'results', []);
      },
    },
  },
  ChuyenMuc: {
    component: dynamic(() => import('@/page/ChuyenMucPage/components/ChuyenMuc')),
    fetchData: {
      showcaseWalls: async (locale, websiteCode, query) => {
        const res = await fetchPostsByShowcaseWalls(websiteCode, {
          ...pick(query ?? {}, []),
          status: 'active',
          limit: 999,
          languageCode: locale,
          onlyGet: false,
          sortBy: 'createdAt:asc',
        });
        const showcaseWalls = get(res, 'results', []);

        const showcaseWallResults = await getPublicPostsByShowcaseWalls(websiteCode, {
          showcaseWalls: showcaseWalls.map((wall) => wall.id),
          limit: 10,
          languageCode: locale,
        });

        showcaseWalls.forEach((wall) => {
          wall.postss = get(showcaseWallResults, 'results', []).filter((post) => post.showcaseWallId === wall.id);
        });
        return showcaseWalls;
      },
    },
  },
  TinTongHop: {
    component: dynamic(() => import('@/page/TinTongHopPage/components/TinTongHop')),
    fetchData: {
      crawlPostss: async (locale, websiteCode, query) => {
        const res = await fetchCrawlPostss(websiteCode, {
          ...pick(query ?? {}, ['page']),
          languageCode: locale,
          limit: 15,
          sortBy: 'pubDate:desc',
        });
        return res;
      },
    },
  },
  BangVanBan: {
    component: dynamic(() => import('@/page/VanBanPage/components/BangVanBan')),
    fetchData: {
      bangVanBan: async (locale, websiteCode, query) => {
        const [postss, categorys] = await Promise.all([
          fetchPostsByMenuSlug(websiteCode, {
            ...pick(query ?? {}, ['titleContent', 'menuSlug', 'coQuanBanHanhIds', 'loaiVanBanIds', 'page']),
            sortBy: 'issuanceDate:desc,createdAt:desc',
            // titleContent: search,
            isPublic: true,
            // menuSlug: slugDetail ?? slug,
            // coQuanBanHanhIds: angency ? [angency] : [],
            // loaiVanBanIds: textType ? [textType] : [],
            limit: 10,
            postType: 'document',
            // page, // sử dụng page hiện tại
            populate: 'loaiVanBanId,coQuanBanHanhId',
          }),
          fetchCategorys(websiteCode, {
            categoryParentCodes: ['co_quan_ban_hanh', 'loai_van_ban'],
            limit: 9999,
            populate: 'categoryGroupId',
          }),
        ]);

        return {
          _data: {
            postss,
            angencies: get(categorys, 'results', []).filter((cat) => cat.categoryGroup?.code === 'co_quan_ban_hanh'),
            textTypes: get(categorys, 'results', []).filter((cat) => cat.categoryGroup?.code === 'loai_van_ban'),
          },
        };
      },
    },
  },
  BangKienNghi: {
    component: dynamic(() => import('@/page/KienNghiCuTriPage/components/BangKienNghi')),
    fetchData: {
      yKienCuTris: async (locale, websiteCode, query) => {
        const res = await fetchYKienCuTris({
          ...pick(query ?? {}, ['content', 'page']),
          limit: 10,
        });
        return res;
      },
    },
  },
  BangDonThu: {
    component: dynamic(() => import('@/page/DonThuPage/components/BangDonThu')),
    fetchData: {
      donThus: async (locale, websiteCode, query) => {
        const res = await fetchDonThus({
          ...pick(query ?? {}, ['content', 'page']),
          populate: 'letterTypeId,senderTypeId,sendMethodId',
          limit: 10,
        });
        return res;
      },
    },
  },
  PdfView: {
    component: dynamic(() => import('@/page/PdfPage/components/PdfView')),
    fetchData: {
      posts: async (locale, websiteCode, query, propsData) => {
        const res = await fetchPostsByMenuSlug(websiteCode, {
          menuSlug: propsData.slugDetail,
          limit: 1,
        });
        return res;
      },
    },
  },
  Lich: {
    component: dynamic(() => import('@/page/LichPage/components/Lich')),
    fetchData: {
      postss: async (locale, websiteCode, query) => {
        const res = await fetchPostsByMenuSlug(websiteCode, {
          ...pick(query ?? {}, ['titleContent', 'menuSlug', 'page']),
          sortBy: 'date:asc',
          isPublic: true,
          limit: 10,
          populate: 'loaiVanBanId,coQuanBanHanhId',
        });
        return res;
      },
    },
  },
  BangDuThao: {
    component: dynamic(() => import('@/page/DuThaoPage/components/BangDuThao')),
    fetchData: {
      draftProposals: async (locale, websiteCode, query) => {
        const res = await fetchDraftDocuments(websiteCode, {
          ...pick(query ?? {}, ['title', 'page']),
          limit: 10,
        });
        return res;
      },
    },
  },
};
